import { MSym } from '@storeo/ui';
import { DemoBanner, PlaceholderTag } from '../components/lumina/Placeholder';

const QUEUE = [
  { id: '#TK-0001', store: 'Loja exemplo A', text: 'Dúvida sobre configuração de domínio próprio.', priority: 'Alta' },
  { id: '#TK-0002', store: 'Loja exemplo B', text: 'Ajuste no webhook de confirmação de entrega.', priority: 'Normal' },
  { id: '#TK-0003', store: 'Loja exemplo C', text: 'Pergunta sobre prazo de repasse PIX.', priority: 'Normal' },
];

/** Admin · Central de Tickets — nova (Fluxo 4 Fase 2), 100% ilustrativa. A Storeo não tem
 *  sistema de suporte/tickets — hoje é conversa direta fora da plataforma. Nomes de loja e
 *  conversa abaixo são fictícios de propósito. */
export function Tickets() {
  return (
    <>
      <div className="relative overflow-hidden rounded-2xl bg-surface-container-low p-space-xl shadow-xl">
        <div className="relative z-10 flex flex-col gap-space-2xs">
          <h1 className="font-headline-lg text-headline-lg text-on-surface font-bold flex items-center gap-2">
            Central de Tickets <PlaceholderTag />
          </h1>
          <p className="font-body-md text-body-md text-on-surface-variant">A Storeo não tem sistema de suporte/tickets hoje — é conversa direta fora da plataforma.</p>
        </div>
      </div>

      <DemoBanner>Nenhum dado real nesta tela — não existe módulo de suporte na Storeo. Fila e conversa abaixo são ilustrativas.</DemoBanner>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-space-md">
        <Kpi icon="timer" label="1ª resposta (FRT)" value="—" />
        <Kpi icon="task_alt" label="Resolução 1º contato" value="—" />
        <Kpi icon="star" label="Satisfação (CSAT)" value="—" />
        <Kpi icon="hourglass_top" label="Fila aberta agora" value="—" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-space-lg">
        <section className="flex flex-col gap-space-sm bg-surface-container-low rounded-2xl p-space-lg shadow-lg opacity-80">
          <h2 className="font-headline-sm text-headline-sm text-on-surface font-bold">Fila de Chamados (exemplo)</h2>
          {QUEUE.map((t) => (
            <div key={t.id} className="p-space-sm rounded-xl bg-surface-container flex flex-col gap-space-3xs">
              <div className="flex items-center justify-between">
                <span className="font-mono text-outline text-label-sm font-label-sm">{t.id}</span>
                <span className="font-label-sm text-label-sm px-space-xs rounded bg-surface-container-highest text-outline">{t.priority}</span>
              </div>
              <span className="text-on-surface font-semibold">{t.store}</span>
              <span className="text-on-surface-variant font-body-sm text-body-sm">{t.text}</span>
            </div>
          ))}
        </section>

        <section className="flex flex-col gap-space-sm bg-surface-container-low rounded-2xl p-space-lg shadow-lg opacity-80">
          <h2 className="font-headline-sm text-headline-sm text-on-surface font-bold">Conversa (exemplo)</h2>
          <div className="flex flex-col gap-space-xs">
            <ChatBubble from="Lojista (exemplo)" text="Consegui configurar o domínio, mas o checkout ainda aponta pro subdomínio antigo." />
            <ChatBubble from="Suporte (exemplo)" mine text="Já ajustei o apontamento — pode testar em janela anônima?" />
          </div>
          <div className="mt-auto flex items-center gap-space-xs pt-space-sm">
            <input disabled placeholder="Sem módulo de suporte real" className="flex-1 bg-surface-container-lowest text-outline placeholder-outline rounded-lg px-space-sm py-space-xs text-body-sm font-body-sm" />
            <MSym name="send" className="text-outline text-[20px]" />
          </div>
        </section>
      </div>
    </>
  );
}

function ChatBubble({ from, text, mine }: { from: string; text: string; mine?: boolean }) {
  return (
    <div className={`max-w-[80%] p-space-sm rounded-xl ${mine ? 'self-end bg-primary-container/30 text-on-surface' : 'bg-surface-container text-on-surface-variant'}`}>
      <span className="block font-label-sm text-label-sm text-outline mb-space-3xs">{from}</span>
      <span className="font-body-sm text-body-sm">{text}</span>
    </div>
  );
}

function Kpi({ icon, label, value }: { icon: string; label: string; value: string }) {
  return (
    <div className="rounded-xl bg-surface-container-low p-space-md shadow-md flex flex-col gap-space-2xs">
      <div className="flex items-center justify-between">
        <span className="font-label-sm text-label-sm uppercase tracking-wider text-outline">{label}</span>
        <MSym name={icon} className="text-[18px] text-outline" />
      </div>
      <span className="font-headline-sm text-headline-sm text-outline font-bold">{value}</span>
    </div>
  );
}
